module.exports = __webpack_public_path__ + "static/SAMSUNG-a859ddc33b1cc1bfcc760e0029ee82d5.mp4";